// extracted by mini-css-extract-plugin
module.exports = {"menu-item-selected":"CurrencyDropdownItem_menu-item-selected__28S18","icon-button":"CurrencyDropdownItem_icon-button__2RCBh","container":"CurrencyDropdownItem_container__1-nHB"};